export default function PageHeader({ eyebrow, title, subtitle, actions, testid }) {
    return (
        <header
            data-testid={testid}
            className="border-b border-border/70 bg-card sticky top-0 z-10"
        >
            <div className="px-8 py-6 flex items-end justify-between gap-6">
                <div>
                    {eyebrow ? <div className="label-tag mb-2">{eyebrow}</div> : null}
                    <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">
                        {title}
                    </h1>
                    {subtitle ? (
                        <p className="mt-1 text-sm text-muted-foreground max-w-xl">
                            {subtitle}
                        </p>
                    ) : null}
                </div>
                {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
            </div>
        </header>
    );
}
